// extracted by mini-css-extract-plugin
module.exports = {"container":"_3aK3V","titleAndContent":"_2IVqD","title":"nxKar","content":"_3EM2q","extraFooterSpacing":"ontwF"};